<template>
  <Fragment>
    <FormSection :name="$t('orderForm.weighing')" :childrenCount="1">
      <StaticInfo :name="$t('orderDetail.materialWeightKg')" :value="value.material_weight_kg" />
    </FormSection>
    <FormSection :childrenCount="3">
      <FormInput
        :name="$t('orderDetail.totalWeightKg')"
        :value="value.total_weight_kg"
        @input="v => updateWeight('total', v)"
        :disabled="disabled"
      />
      <StaticInfo :name="$t('orderDetail.totalWeighedAt')" :value="formattedFromDateTime(value.total_weighed_at)" />
      <StaticInfo :name="$t('orderDetail.weighMethod')" :value="weighMethodTotalText" />
    </FormSection>
    <FormSection :childrenCount="3">
      <FormInput
        :name="$t('orderDetail.tareWeightKg')"
        :value="value.tare_weight_kg"
        @input="v => updateWeight('tare', v)"
        :disabled="disabled"
      />
      <StaticInfo :name="$t('orderDetail.tareWeighedAt')" :value="formattedFromDateTime(value.tare_weighed_at)" />
      <StaticInfo :name="$t('orderDetail.weighMethod')" :value="weighMethodTareText" />
    </FormSection>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import FormInput from '@/components/Form/Input/index.vue'
import StaticInfo from '@/components/Form/StaticInfo/index.vue'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'WeightSection',
  components: { StaticInfo, FormInput, Fragment },
  mixins: [dateUtils],
  props: {
    value: { type: Object, required: true },
  },
  computed: {
    weighMethodTotalText() {
      return this.weighMethodText(
        this.value.weigh_station_of_total_weight_name,
        this.value.total_weighed_at,
        this.value.total_weight_kg,
      )
    },
    weighMethodTareText() {
      return this.weighMethodText(
        this.value.weigh_station_of_tare_weight_name,
        this.value.tare_weighed_at,
        this.value.tare_weight_kg,
      )
    },
    disabled() {
      if (this.value.status == 'open' || this.value.status == 'assigned') {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    updateWeight(weightName, value) {
      if (!['total', 'tare'].includes(weightName)) throw 'invalid weight type'

      // we update these things locally so the form state reflects the state the backend would return after updating the
      // weight. These are not actually posted though. See orders controller in the backend
      this.$emit('input', {
        ...this.value,
        [`${weightName}_weight_kg`]: value,
        [`${weightName}_weighed_at`]: null,
        [`weigh_station_of_${weightName}_weight_name`]: null,
      })
    },
    weighMethodText(name, weighedAt, weightKg) {
      if (name) return this.$t('orderDetail.weighedWith', { name })
      if (weighedAt) return this.$t('orderDetail.weighedManually')
      if (weightKg) return this.$t('orderDetail.enteredManually')
      return '-'
    },
  },
}
</script>
